module.exports = __webpack_public_path__ + "static/OGWII_S1-11.2_lazienka_parter_02-2427b3914af8bafae6087ddec9869fa1.jpg";